<template lang="html">
  <v-menu
    offset-x left
    :close-on-content-click="false"
    :nudge-width="300"
  >
    <v-btn icon ripple slot="activator">
      <v-icon color="grey lighten-1">info</v-icon>
    </v-btn>
    <v-card>
      <v-list two-line dense>
        <v-list-tile v-if="user.name">
          <v-list-tile-avatar>
            <!-- <img :src="getUserAvatarPath('women')" alt="Стартер"> -->
            <img v-if="user.image" :src="user.image"/>
            <v-icon v-else color="grey">face</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ user.name }}</v-list-tile-title>
            <v-list-tile-sub-title v-if="user.post">{{ user.post }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="" v-if="user.phone">
          <v-list-tile-action>
            <v-icon color="indigo">phone</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ user.phone }}</v-list-tile-title>
            <v-list-tile-sub-title>Телефон</v-list-tile-sub-title>
          </v-list-tile-content>
          <!-- <v-list-tile-action>
            <v-icon>chat</v-icon>
          </v-list-tile-action> -->
        </v-list-tile>
        <!-- <v-list-tile @click="">
          <v-list-tile-action>
            <v-icon color="indigo">phone</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ user.workPhone }}</v-list-tile-title>
            <v-list-tile-sub-title>Рабочий телефон</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile> -->
        <v-divider></v-divider>
        <v-list-tile @click="" v-if="user.email">
          <v-list-tile-action>
            <v-icon color="indigo">mail_outline</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ user.email }}</v-list-tile-title>
            <v-list-tile-sub-title>Электронный адрес</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile @click="" v-if="user.address">
          <v-list-tile-action>
            <v-icon color="indigo">place</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ user.address }}</v-list-tile-title>
            <v-list-tile-sub-title>Адрес</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import commons from '../../mixins/commons'
import time_limit from '../../mixins/time_limit'
import monitor from '../../mixins/monitor'

export default {
  mixins: [commons, time_limit, monitor],

  props: ['user']
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/apps/bpm/superMonitor/components/UserInfoPopup.vue